import { defineStore } from 'pinia';
import DemandeContactAjax from '@/services/DemandeContactAjax';
import useAppStore from '@/store/appStore';

export default defineStore('demandeContactStore', {
  state: () => ({
    chargement: false,
    envoiReussi: false,
  }),
  getters: {},
  actions: {
    async envoyer(demande) {
      try {
        this.chargement = true;
        this.envoiReussi = await DemandeContactAjax.envoyer(demande);
      } catch (e) {
        useAppStore().erreur = e;
      } finally {
        this.chargement = false;
      }
    },
  },
});
